import React from "react";
import Footer from "../Footer/Footer";
import Aside from "../Aside/Aside";
import "./Layout.css";
import Nav from "../Nav/Nav";

const Layout = ({ children, mostrarAside, materiaSeleccionada }) => (
  <div className="layout-wrapper">
    <Nav />
    <div className="container mt-4 content-wrapper">
      <div className="row justify-content-center">
        <main className={mostrarAside ? "col-md-8" : "col-md-10"}>{children}</main>
        {mostrarAside && (
          <aside className="col-md-4">
            <Aside materia={materiaSeleccionada} />
          </aside>
        )}
      </div>
    </div>
    <Footer />
  </div>
);


export default Layout;